import {
  CANCEL_METAL_GOALS,
  CREATE_POT,
  GET_POT_LIST,
  CREATE_GOLD_POT,
  GOLDSILVER_POT_CHECK,
  CANCEL_MF_GOALS,
  GIFT_INVESTMENT_SUCCESS,
  GIFT_INVESTMENT_FAIL,
  NOTIFICATIONS_SUCCESS,
  NOTIFICATIONS_FAIL,
  SELL_METAL_GOALS,
} from "./types";
import {
  TRANSACTION_BASE_URL,
  GOAL_POT_URL,
  CREATE_FUNDING_RULES,
  CREATE_GOLDFUNDING_RULES,
  GET_GOALS_LIST,
  GS_POT_CHECK,
  GOAL_CANCEL_METEL,
  GOAL_CANCEL_MF,
  SELL_API_GOALMETAL,
  PAYMENT_BASE_URL,
} from "../../Api/EndPoints";
import { APIClient } from "../../Api/APIClient";
import * as Models from "models";

export function CreatePOT(req: any, token: string) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: CREATE_POT });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .postData(TRANSACTION_BASE_URL + GOAL_POT_URL, JSON.stringify(req), token)
          .then((response: any) => {
            let result = response;
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            reject(errorMessage);
          });
      }
    });
}

export function CreateFundingRules(req: any, token: string) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: CREATE_POT });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .postData(TRANSACTION_BASE_URL + CREATE_FUNDING_RULES, JSON.stringify(req), token)
          .then((response: any) => {
            let result = response;
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            reject(errorMessage);
          });
      }
    });
}

export function CreateGoldFundingRules(req: any, token: string) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: CREATE_GOLD_POT });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .postData(
            TRANSACTION_BASE_URL + CREATE_GOLDFUNDING_RULES,
            JSON.stringify(req),
            token
          )
          .then((response: any) => {
            let result = response;
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            reject(errorMessage);
          });
      }
    });
}

export function getPOTList(id: string, token: any, investmentAccId: any) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: GET_POT_LIST });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .getRequest(
            TRANSACTION_BASE_URL + GET_GOALS_LIST + +id + "/" + investmentAccId,
            token
          )
          .then((response: any) => {
            let result = response;
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            reject(errorMessage);
          });
      }
    });
}

export function GSPOTOrderStatus(req: any, token: string) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: GOLDSILVER_POT_CHECK });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .postData(TRANSACTION_BASE_URL + GS_POT_CHECK, req, token)
          .then((response: any) => {
            let result = response;
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            reject(errorMessage);
          });
      }
    });
}

export function cancelGoalMetalGoals(
  req: Models.CancelMetalGoalRequest,
  token: string
) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: CANCEL_METAL_GOALS });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .postData(TRANSACTION_BASE_URL + GOAL_CANCEL_METEL, JSON.stringify(req), token)
          .then((response: any) => {
            let result = response;
            getInvestmentSuccess(dispatch, result);
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            getInvestmentFailed(dispatch, errorMessage);
            reject(errorMessage);
          });
      }
    });
}

export function cancelMFGoalMetalGoals(virtualId: string, token: any) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: CANCEL_MF_GOALS });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .postData(PAYMENT_BASE_URL + GOAL_CANCEL_MF + virtualId, {}, token)
          .then((response: any) => {
            let result = response;
            getNotificationSuccess(dispatch, result);
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            if (error?.status === 401) {
              getNotificationSuccess(dispatch, error);
              resolve(error);
              return;
            }
            getNotificationFailed(dispatch, errorMessage);
            reject(errorMessage);
          });
      }
    });
}

export function sellGoalMetalGoals(
  req: Models.CancelMetalGoalRequest,
  token: string
) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: SELL_METAL_GOALS });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .postData(TRANSACTION_BASE_URL + SELL_API_GOALMETAL, JSON.stringify(req), token)
          .then((response: any) => {
            let result = response;
            getInvestmentSuccess(dispatch, result);
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            getInvestmentFailed(dispatch, errorMessage);
            reject(errorMessage);
          });
      }
    });
}

const getInvestmentSuccess = (
  dispatch: (arg0: { type: string; payload: any }) => void,
  errorMessage: any
) => {
  dispatch({
    type: GIFT_INVESTMENT_SUCCESS,
    payload: errorMessage,
  });
};

const getInvestmentFailed = (
  dispatch: (arg0: { type: string; payload: any }) => void,
  errorMessage: any
) => {
  dispatch({
    type: GIFT_INVESTMENT_FAIL,
    payload: errorMessage,
  });
};

const getNotificationFailed = (
  dispatch: (arg0: { type: string; payload: any }) => void,
  errorMessage: any
) => {
  dispatch({
    type: NOTIFICATIONS_FAIL,
    payload: errorMessage,
  });
};
const getNotificationSuccess = (
  dispatch: (arg0: { type: string; payload: any }) => void,
  errorMessage: any
) => {
  dispatch({
    type: NOTIFICATIONS_SUCCESS,
    payload: errorMessage,
  });
};
